export default {
	apiKey: "AIzaSyB9_cxRdt0lOeEFcEr-ss5D_byy1hvTwF8",
	authDomain: "ayun-quantity-preprod.firebaseapp.com",
	projectId: "ayun-quantity-preprod",
	storageBucket: "ayun-quantity-preprod.appspot.com",
	messagingSenderId: "1071975881175",
	appId: "1:1071975881175:web:49f71ae0855a2bac889392",
	measurementId: "G-GZL6QZZM3C"
};
